import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { InvoicingApiCategory } from '../types/invoicingApiCategory'

const invoicingCategoryMap: Partial<Record<InvoiceDocumentType, InvoicingApiCategory>> = {
  [InvoiceDocumentType.CreditNote]: 'creditnotes',
  [InvoiceDocumentType.DeliveryNote]: 'deliverynotes',
  [InvoiceDocumentType.Quote]: 'estimates',
  [InvoiceDocumentType.Invoice]: 'invoices',
}

export const getInvoicingApiCategory = (documentType: InvoiceDocumentType): InvoicingApiCategory => {
  return invoicingCategoryMap[documentType] || 'invoices'
}
